import { render, staticRenderFns } from "./CalendarEventModal.vue?vue&type=template&id=665d2e3f&scoped=true"
import script from "./CalendarEventModal.vue?vue&type=script&lang=js"
export * from "./CalendarEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d2e3f",
  null
  
)

export default component.exports